export default "__VITE_ASSET__ClE96R5Q__"